import { ContentBlock, EditorState, Modifier } from 'draft-js';
import { FollowupData } from '../types';
import followupTextSelection from '../utils/followupTextSelection';

export default function updateFollowup(
  editorState: EditorState,
  focusedBlock: ContentBlock,
  newFollowup: FollowupData,
  entityKey: string,
): EditorState {
  const currentSelectionState = editorState.getSelection();
  const followupSelection = followupTextSelection(editorState, newFollowup, focusedBlock.getKey());
  const contentStateWithUpdatedEntity = editorState
    .getCurrentContent()
    .replaceEntityData(entityKey, newFollowup);
  const followupReplacedContent = Modifier.applyEntity(
    contentStateWithUpdatedEntity,
    followupSelection,
    entityKey,
  );
  const newEditorState = EditorState.push(editorState, followupReplacedContent, 'insert-fragment');

  return EditorState.forceSelection(newEditorState, currentSelectionState);
}
